<div class="card-title-block-non-sticky" *ngIf="hasBatchDetailsError && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>batch-card.data-not-found</span>
</div>
<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="batch && !hasBatchDetailsError">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>batch.card</span>
					<span class="card-title-label">{{ batch.batchReference }}</span>
					<div class="button-quality-feedback">
						<button type="button" mat-flat-button
							*ngIf="user.hasService('PCALL') && batch.callable === 'O'"
							[disabled]="batch === undefined"
							(click)="createCallOff()">
							<span translate>batch-card.create-call-off</span>
							<mat-icon iconPositionEnd class="add-icon" svgIcon="add"></mat-icon>
						</button>
						<button type="button" mat-flat-button
							*ngIf="hasClaimService && !this.user.isClaimStrictlyReader() && this.claimBatch && this.claimBatch.isClaimable"
							[disabled]="batch === undefined"
							(click)="setMainBatchOnClaim()">
							<span translate>claim.raise-new-quality-issue</span>
							<mat-icon iconPositionEnd class="add-icon" svgIcon="add"></mat-icon>
						</button>
					</div>
				</div>
				<div class="grid-6 copo-container footer-margin" copoAfterViewInit
					(afterviewinit)="scroller.restoreState()">
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>batch.card.information</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-content-block">
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>order.customer.article.reference</div>
									<div class="card-content-value">{{ batch | copoModelInfo: 'customerArticleReference'
										}}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.customer.order.number</div>
									<a class="card-content-value copo-link"
										[routerLink]="['/order-tracking/order/card', batch.supplierOrderNumber, batch.supplierOrderItemNumber]">{{
										batch.customerOrderNumber }}/{{ batch.customerOrderItemNumber }}</a>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.supplier.order.number</div>
									<a class="card-content-value copo-link"
										[routerLink]="['/order-tracking/order/card', batch.supplierOrderNumber, batch.supplierOrderItemNumber]">{{
										batch.supplierOrderNumber }}/{{ batch.supplierOrderItemNumber }}</a>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.mill.order.number</div>
									<div class="card-content-value">{{ batch.millOrderNumber}}/{{
										batch.millOrderItemNumber }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.package-serial-number</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'packageSerialNumber' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>datacenter-filter.loading-program-number</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'loadingProgramNumber' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>datacenter-filter.carrier-name</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'carrierNameConcat' }}
									</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>order.steelgrade</div>
									<div class="card-content-value">{{ batch | copoModelInfo: 'steelgradeDescription' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.thickness</div>
									<div class="card-content-value">{{ batch.thickness | copoNumber: 'thickness':'mm' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.width</div>
									<div class="card-content-value">{{ batch.width | copoNumber: 'width':'mm'}}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.length</div>
									<div class="card-content-value" *ngIf="batch.length !== 0">{{ batch.length | copoNumber: 'length-mm':'mm' }}</div>
									<div class="card-content-value" *ngIf="batch.length === 0">{{ UNDERSCORE }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>datacenter-filter.producedLength</div>
									<div class="card-content-value">
										{{ producedLengthInMeters !== null ? producedLengthInMeters : UNDERSCORE }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.heat-number</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'heatNumber' }}</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.net</div>
									<div class="card-content-value">{{ batch.qtyBatchNet | copoNumber: 'weight':'t' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.gross</div>
									<div class="card-content-value">{{ batch.qtyBatchGross | copoNumber: 'weight':'t' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.final-use</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'finalUseDescription' }}
									</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.mill</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'millDescription' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.supplier.invoice.number</div>
									<div class="card-content-value">{{ batch.supplierInvoiceNumber ? batch.supplierInvoiceNumber : UNDERSCORE }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.invoice.date</div>
									<div class="card-content-value">{{ batch.invoiceDate ? (batch.invoiceDate | copoDate:'date'): UNDERSCORE }}</div>
								</div>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.card.followup</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-content-block">
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.date-for-dispatch</div>
									<div class="card-content-value">{{ batch.readyToShipDate ? (batch.readyToShipDate |
										copoDate:'date') : UNDERSCORE }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.planned-loading-date</div>
									<div class="card-content-value">{{ batch.plannedShipmentDate ?
										(batch.plannedShipmentDate | copoDate:'date') : UNDERSCORE }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.stock-alert</div>
									<div class="card-content-value"> <mat-icon [svgIcon]="getStockAlertIcon(batch.stockAlert)" [title]="getStockAlertTranslation(batch.stockAlert) | translate"></mat-icon></div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.current-location</div>
									<div class="card-content-value">{{ batch | copoModelInfo: 'currentLocationDescription'
										}}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batches.number.of.day.in.stock</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'daysInStock' }}</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.status</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'statusGroupDescription' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>batch.detailed-batch-status</div>
									<div class="card-content-value">{{ batch | copoModelInfo:'statusDescription' }}
									</div>
								</div>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full card-block"
					*ngIf="shipmentData && shipmentData.length > 0 && shipmentTracking && shipmentTracking.length > 0">
					<mat-expansion-panel [expanded]="true">
						<mat-expansion-panel-header>
							<mat-panel-title class="card-title">
								<span translate>batch-card.shipments</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-infos-block">
							<div class="stepper-horizontal">
								<div class="step" *ngFor="let shipment of shipmentTracking">
									<div class="step-icon date-color"><mat-icon svgIcon="geo-alt"></mat-icon></div>
									<div class="step-circle">

										<p class="transport-mode" *ngIf="isLastIndexObject(shipmentTracking.indexOf(shipment))">
											<mat-icon class="icon-class" [svgIcon]="getTransportModeIcon(shipment.transportMode)"></mat-icon>
											<span>{{shipment.transportModeDescription}}</span>

										</p>
										<p class="transport-reference" *ngIf="isLastIndexObject(shipmentTracking.indexOf(shipment))">
											{{shipment.transportReference}}</p>
									</div>
									<div class="step-title">{{shipment.location}}</div>
									<div class="step-title">{{shipment.dispatchAdviceNumber}}</div>
									<div class="date-color">{{shipment.shipmentReferenceDate}}</div>
									<div
										[ngClass]="{'step-bar-left': isLastIndexObject(shipmentTracking.indexOf(shipment)), 'step-bar-grey': !isLastIndexObject(shipmentTracking.indexOf(shipment)) && batch.statusGroupDescription !== 'Delivered'}">

									</div>
								</div>
								<div class="step" *ngIf="batch.statusGroupDescription !== 'Delivered'">
									<div class="step-icon"><mat-icon svgIcon="geo-alt"></mat-icon></div>
									<div class="step-circle"><span></span></div>
								</div>
							</div>
						</div>
					</mat-expansion-panel>
				</div>
					<div class="grid-column-one-full"
						*ngIf="gridCommercialDocumentsOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order-card.commercial-documents</span>
								</mat-panel-title>
								<div *ngIf="documentResults && documentResults.results && documentResults.results.length > 0">
									<a color="primary" (click)="$event.preventDefault();seeAllDocuments()" class="view-all" href="#">
										<span translate>see.all.documents</span>
									</a>
								</div>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular *ngIf="!hasCommercialDocumentError" class="ag-theme-balham" [gridOptions]="gridCommercialDocumentsOptions"
								[overlayNoRowsTemplate]="overlayNoRowsTemplate" [modules]="agGridModules" (gridReady)="onGridReady($event)"
								(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
							<div *ngIf="hasCommercialDocumentError" class="document-error-box">
								<div translate>order-card.due-to-technical-issue</div>
								<mat-icon class="error-icon" svgIcon="md:running_with_error"></mat-icon>
								<div translate>order-card.we-are-actively-working</div>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>
